import React from "react";

import { getAdminVerificationYearlyDataYear } from "utils";

import { AdminHead, ErrorBoundary, MainPage, Tabs } from "components";

import { CertificationYearTab } from "pages/admin/verifications/components/certifications/CertificationYearTab";

const START_YEAR = 2025;

export const Certifications = () => {
  const currentYear = getAdminVerificationYearlyDataYear();

  const years = Array.from({ length: currentYear - START_YEAR + 1 }, (_, i) => START_YEAR + i);

  const tabItems = years.map((year) => ({
    label: String(year),
    key: String(year),
    children: (
      <ErrorBoundary>
        <CertificationYearTab year={year} />
      </ErrorBoundary>
    ),
  }));

  return (
    <MainPage pageName="admin">
      <AdminHead headline="Certifications" />
      <Tabs size="small" items={tabItems} />
    </MainPage>
  );
};
